import React from 'react';
import { Dialog, Pane, Button, Tooltip, FolderNewIcon, Text, TextInput } from 'evergreen-ui';

import { ToolButton } from './Folders';

 let FolderButton = (props) => <Button
    overflowY={"hidden"}
    height="100%"
    display="flex"
    justifyContent="left"
    background={props.background}
    flex={1}
    isActive={props.isActive}
    onClick={() => { props.onClick && props.onClick(); }}
>
    {props.children}
    {!props.children && <>
        {/* <FileIcon
            ext={props.book?.split('.').pop()} /> */}

        <div className="dxfsvf" dangerouslySetInnerHTML={{ __html: props.svg }} />
        {props.book}</>}
</Button>
;



export function NewFolderDialog(props) {
    const [isShown, setIsShown] = React.useState(false);
    const [name, setName] = React.useState('New Folder');
    const handleFocus = (e) => {
        e.target.select();
    }
    return (
        <>
            <Dialog
                isShown={isShown}
                title="Create New Folder"
                intent="primary"
                onCloseComplete={() => setIsShown(false)}
                confirmLabel="Confirm"
                shouldCloseOnOverlayClick={false}
                onConfirm={() => { props.onNew(name ? name : "New Folder"); setIsShown(false); }}
            ><Pane display={"flex"} justifyContent={"center"} alignItems={"left"} flexDirection={"column"}>
                    <Pane display={"flex"} justifyContent={"left"} alignItems={"center"} flexDirection={"row"} gap={"5px"} marginBottom={"10px"}>
                        <Text>Folder Name: </Text>
                        <TextInput defaultValue='New Folder' autoFocus onFocus={(e)=>handleFocus(e)} onChange={(e) => setName(e.target.value)} />
                    </Pane>
                    <Text>Are you sure you want to create this folder?</Text>
                </Pane>
            </Dialog>

            <FolderButton title="Create New Folder"  onClick={() => setIsShown(true)} cursor={"pointer"}
                            key="newfolder" background="greenTint">
            <FolderNewIcon>{props.children}</FolderNewIcon></FolderButton>

        </>
    );
}
